document.addEventListener("DOMContentLoaded", () => {
  // ドロップダウンの挙動を設定
  const dropdowns = document.querySelectorAll(".c-search-dropdown");

  dropdowns.forEach((dropdown) => {
    const selected = dropdown.querySelector(".c-search-dropdown__selected");
    const options = dropdown.querySelector(".c-search-dropdown__options");
    const hiddenInput = dropdown.querySelector("input[type='hidden']");

    if (!selected || !options || !hiddenInput) {
      console.error("必要な要素が見つかりません");
      return;
    }

    // ドロップダウンを開閉する
    selected.addEventListener("click", () => {
      options.style.display =
        options.style.display === "block" ? "none" : "block";
    });

    // オプションをクリックしたときの処理
    options.addEventListener("click", (event) => {
      const target = event.target.closest(".c-search-dropdown__option");
      if (target) {
        selected.innerHTML = target.innerHTML;
        hiddenInput.value = target.getAttribute("data-value");
        options.style.display = "none";
      }
    });

    // ドロップダウン外をクリックしたら閉じる
    document.addEventListener("click", (event) => {
      if (!dropdown.contains(event.target)) {
        options.style.display = "none";
      }
    });
  });

  // フォーム送信時に行うアクション
  const form = document.getElementById("obj_search_home");
  if (!form) {
    return; // フォームがない場合は処理を終了
  }
  form.addEventListener("submit", (event) => {
    // 子供と添い寝の値を取得
    const kidsInput = document.querySelector("#select_kids_home");
    const babyInput = document.querySelector("#select_baby_home");

    // 子供の値を取得（デフォルト値: "h1_0"）
    const kidsValue = kidsInput ? kidsInput.value : "h1_0";

    // 添い寝の値を取得（デフォルト値: "h2_0"）
    const babyValue = babyInput ? babyInput.value : "h2_0";

    // パラメータを作成して結合
    const ccValue = `${kidsValue}:${babyValue}`;

    // フィールドを取得してvalueを更新
    let ccInput = document.querySelector("input[name='mc_child_cnt']");
    let ccInput_room = document.querySelector("input[name='cc']");

    // TOP
    if (ccInput) {
      ccInput.value = ccValue;
    }
    //ROOM
    if (ccInput_room) {
      ccInput_room.value = ccValue;
    }
  });
});

// タブ切り替え
const tabMenus = document.querySelectorAll(".c-search-header__list li");
const radioButtons = document.querySelectorAll("input[name='stay_option']");

// イベント付加
tabMenus.forEach((tabMenu) => {
  tabMenu.addEventListener("click", tabSwitch);
});

radioButtons.forEach((radioButton) => {
  radioButton.addEventListener("change", tabSwitchByRadio);
});

// タブ切り替え処理（クリック時）
function tabSwitch(e) {
  const tabTargetData = e.currentTarget.dataset.tab;
  switchTab(tabTargetData);
}

// タブ切り替え処理（ラジオボタン変更時）
function tabSwitchByRadio(e) {
  const tabTargetData = e.target.value; // ラジオボタンのvalueを取得
  switchTab(tabTargetData);
}

// 共通のタブ切り替えロジック
function switchTab(tabTargetData) {
  const tabItems = document.querySelectorAll(".c-search-header__list li");
  const tabPanelItems = document.querySelectorAll(".c-search-tab");

  // タブメニューのクラスをリセット
  tabItems.forEach((tabItem) => {
    tabItem.classList.remove("current");
  });

  // タブパネルのクラスをリセット
  tabPanelItems.forEach((tabPanelItem) => {
    tabPanelItem.classList.remove("current");
  });

  // 対象のタブメニューにクラスを付与
  tabItems.forEach((tabItem) => {
    if (tabItem.dataset.tab === tabTargetData) {
      tabItem.classList.add("current");
    }
  });

  // 対象のタブパネルにクラスを付与
  tabPanelItems.forEach((tabPanelItem) => {
    if (tabPanelItem.dataset.panel === tabTargetData) {
      tabPanelItem.classList.add("current");
    }
  });
}
